import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Table, Popup, Button, Icon } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { useNavigate } from "react-router-dom";
import { IBrokerMarket } from "../../../app/models/broker";
import { getCompanyStateEnum } from "../../../app/util/securityEnumsOptions";
import { CompanyStateEnum } from "../../../app/util/securityEnums";

const ListBroker = () => {
  const navigate = useNavigate();

  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    brokers,
    getBrokers,
    loadData,
    changeBrokerState,
  } = rootStore.brokerStore;

  useEffect(() => {
    getBrokers();
  }, [getBrokers]);

  const handleChangeState = (b: IBrokerMarket, state: CompanyStateEnum) => {
    changeBrokerState({ id: b.id, state: state });
  };

  if (!loadData) return <LoadingComponent content="Cargando" />;
  return (
    <div className="TableScroll">
    <Table striped basic unstackable compact singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Nombre</Table.HeaderCell>
          <Table.HeaderCell>NIT</Table.HeaderCell>
          <Table.HeaderCell>Dirección</Table.HeaderCell>
          <Table.HeaderCell>Teléfono</Table.HeaderCell>
          <Table.HeaderCell>Correo</Table.HeaderCell>
          <Table.HeaderCell>Estado</Table.HeaderCell>
          <Table.HeaderCell>Acciones</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {brokers?.length > 0 ? (
          brokers.map((b) => (
            <Table.Row key={b.id}>
              <Table.Cell singleLine>{b.name}</Table.Cell>
              <Table.Cell>{b.companyID}</Table.Cell>
              <Table.Cell singleLine>{b.address.line}</Table.Cell>
              <Table.Cell>{b.contact.phone}</Table.Cell>
              <Table.Cell>{b.contact.email}</Table.Cell>
              <Table.Cell>{getCompanyStateEnum(b.state)}</Table.Cell>
              <Table.Cell>
                <div>
                  <Popup
                    content="Editar agente"
                    trigger={
                      <Button
                        icon
                        onClick={() =>
                          navigate(
                            `/home/Configuration/Broker/DashboardEditBroker/${b.id}`
                          )
                        }
                      >
                        <Icon name="edit outline" color="blue" />
                      </Button>
                    }
                  />
                  {b.state === CompanyStateEnum.Active ? (
                    <Popup
                      content="Click para Inactivar agente"
                      trigger={
                        <Button
                          icon
                          onClick={() => handleChangeState(b, CompanyStateEnum.Inactive)}
                        >
                          <Icon name="unlock" color="green" />
                        </Button>
                      }
                    />
                  ) : (
                    <Popup
                      content="Click para Activar usuario"
                      trigger={
                        <Button icon onClick={() => handleChangeState(b, CompanyStateEnum.Active)}>
                          <Icon name="lock" color="red" />
                        </Button>
                      }
                    />
                  )}
                </div>
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row key="brokerNull">
            <Table.Cell>No existen Agentes</Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
    </div>
  );
};

export default observer(ListBroker);
